<template>
  <span class="publisher"><a :href="link" target="_blank">{{ name }}</a></span>
</template>

<script>
export default {
  name: 'PublisherComponent',
  props: ['name', 'link'],
};
</script>

<style scoped>
.publisher a {
  color: rgb(167, 167, 167);
  text-decoration: none;
}

.voodoo .publisher a {
  color: black;
}
</style>
